import axios from "axios";
import Result from "../utils/result.utils";
import { DealBuilderSavedFormat } from "../../pricing-management/hooks/useDatabaseAPI";

export type UpsertDealInput = DealBuilderSavedFormat & {
    user_id: string
}

// @ts-ignore
const DATABASE_API_URL = process.env.REACT_APP_API_URL;

export default class PrimaryDatabaseAPI {

    public static async upsertDeal(token: string, deal: DealBuilderSavedFormat): Promise<Result<undefined>> {
        const path = DATABASE_API_URL + "/v3/deals";
        try {
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { status } = await axios.post(path, deal, config);
            if (status !== 200) return { valid: false, error: "We couldn't update your deal." };
            return { valid: true };
        } catch (_e) {
            return { valid: false, error: "We couldn't update your deal." };
        }
    }

    public static async getDeals(token: string): Promise<Result<DealBuilderSavedFormat[]>> {
        const path = DATABASE_API_URL + "/v3/deals";
        try {
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { status, data } = await axios.get(path, config);
            if (status !== 200) return { valid: false, error: "We couldn't fetch your deals." };
            return { valid: true, body: data };
        } catch (_e) {
            return { valid: false, error: "We couldn't fetch your deals." };
        }
    }

    public static async deleteDeal(token: string, dealId: string): Promise<Result<undefined>> {
        const path = DATABASE_API_URL + "/v3/deals/" + dealId;
        try {
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { status } = await axios.delete(path, config);
            if (status !== 200) return { valid: false, error: "Deal not found." };
            return { valid: true };
        } catch (_e) {
            return { valid: false, error: "We couldn't delete your deal." };
        }
    }

}

